/**
 * Scopes Shopify `form.posted_successfully?` / `form.errors` messages to only the
 * customer form that was actually submitted.
 *
 * Shopify marks *all* customer forms on the page as posted successfully after a
 * customer form POST + redirect, so we persist the last submitted form key in
 * sessionStorage and hide messages for non-matching forms.
 */

const STORAGE_KEY = 'customerForm:lastKey';

function getCustomerFormKey(form) {
  if (!(form instanceof HTMLFormElement)) return null;

  const keyedEl =
    form.querySelector('[data-customer-form-key]') ||
    form.querySelector('input[name="customer_form_key"]');

  if (!keyedEl) return null;

  const datasetKey = keyedEl.getAttribute('data-customer-form-key');
  if (datasetKey) return datasetKey;

  if (keyedEl instanceof HTMLInputElement && keyedEl.value) return keyedEl.value;

  return null;
}

function scopeCustomerFormMessages() {
  let lastKey = null;
  try {
    lastKey = window.sessionStorage.getItem(STORAGE_KEY);
  } catch (_) {
    // no-op
  }

  if (!lastKey) return;

  const messageEls = document.querySelectorAll(
    '[data-customer-form-message][data-customer-form-key]'
  );

  messageEls.forEach((el) => {
    const elKey = el.getAttribute('data-customer-form-key');
    if (!elKey) return;

    if (elKey !== lastKey) {
      // Use inline style to avoid coupling to a particular CSS framework.
      el.style.display = 'none';
    }
  });
}

function scheduleScope() {
  // Collapse multiple DOM mutations into one pass.
  if (scheduleScope._scheduled) return;
  scheduleScope._scheduled = true;
  requestAnimationFrame(() => {
    scheduleScope._scheduled = false;
    scopeCustomerFormMessages();
  });
}

// Capture submit before navigation.
document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    const key = getCustomerFormKey(form);
    if (!key) return;

    try {
      window.sessionStorage.setItem(STORAGE_KEY, key);
    } catch (_) {
      // no-op
    }
  },
  true
);

// After redirect, hide success/errors for other customer forms.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scopeCustomerFormMessages);
} else {
  scopeCustomerFormMessages();
}

// Sections like related products are injected after page load; re-scope messages
// when new nodes appear.
try {
  const observer = new MutationObserver(() => scheduleScope());
  observer.observe(document.documentElement, { childList: true, subtree: true });
} catch (_) {
  // no-op
}
